<section id="info" class="info">
  <div class="info-inner">
    <div class="info-grid">
      <div>
        <div ppcEyebrow mark>{{ 'info.eyebrow' | translate }}</div>
        <h2 ppcHeading class="info-title">{{ 'info.title' | translate }}</h2>

        <div class="info-hours">
          @for (hour of hours(); track $index) {
            <div class="info-hour" [class.is-closed]="hour.closed" [class.is-today]="hour.today">
              <div class="info-hour-day">
                {{ hour.day }}
                @if (hour.today) {
                  <span class="info-hour-today">{{ 'info.today' | translate }}</span>
                }
              </div>
              <div class="info-hour-time">
                @for (range of hour.ranges; track $index; let last = $last) {
                  <span class="info-hour-range">{{ range }}</span>
                  @if (!last) {
                    <span class="info-hour-sep" aria-hidden="true">·</span>
                  }
                }
              </div>
            </div>
          }
        </div>

        <div class="info-contact">
          <div class="info-row">
            <div ppcEyebrow class="info-row-key">{{ 'info.addressLabel' | translate }}</div>
            <div class="info-row-val">{{ 'company.address' | translate }}</div>
          </div>
          <div class="info-row">
            <div ppcEyebrow class="info-row-key">{{ 'info.phoneLabel' | translate }}</div>
            <div class="info-row-val">
              <a [href]="phoneHref()">{{ 'company.phone' | translate }}</a>
            </div>
          </div>
          <div class="info-row">
            <div ppcEyebrow class="info-row-key">{{ 'info.emailLabel' | translate }}</div>
            <div class="info-row-val">{{ 'company.email' | translate }}</div>
          </div>
          <div class="info-row">
            <div ppcEyebrow class="info-row-key">{{ 'info.socialLabel' | translate }}</div>
            <div class="info-row-val">
              <a [href]="'company.facebook' | translate" target="_blank" rel="noreferrer">{{ 'info.facebook' | translate }}</a>
              {{ 'info.socialSep' | translate }}
              <a [href]="'company.instagram' | translate" target="_blank" rel="noreferrer">{{ 'info.instagram' | translate }}</a>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="info-map">
          <iframe
            [title]="'info.mapTitle' | translate"
            [src]="mapUrl"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</section>
